<template>
  <div :class="stepStatus == 4 && dataDetails.isCommon==1? 'clickNone' : ''">

    <!-- ────────────────────────────────────────
         Block 1: 是否有变更  （原 switchRow）
    ──────────────────────────────────────────-->
    <div class="ni-change-banner">
      <div class="ni-change-banner__text">
        <span class="ni-change-banner__label">{{ $t("coll.hasChanges") }}</span>
        <span class="ni-change-banner__hint">{{ $t("coll.changeHint") }}</span>
      </div>
      <van-switch v-model="hasChanges" size="24" />
    </div>

    <div class="ni-group-label">{{ $t("coll.nationalityAndId") }}</div>
    <div class="ni-card">

      <!-- 国籍 row -->
      <div class="ni-row" @click="showPicker()">
        <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.nationality") }}</span>
        <span class="ni-row__value" :class="[!country ? 'ni-row__value--placeholder' : '', !hasChanges ? 'ni-row__value--disabled' : '']">
          {{ country || $t('coll.choose') }}
        </span>
        <i class="ni-chevron" :class="!hasChanges ? 'ni-chevron--disabled' : ''">›</i>
      </div>

      <!-- 证件号 row -->
      <div class="ni-row ni-row--input">
        <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t(isChina ? "coll.idCardNumber" : "coll.passportNumber") }}</span>
        <van-field
          v-model="step_data.license_number"
          :placeholder="$t('global.please_input')"
          :disabled="!hasChanges"
          class="ni-inline-field"
        />
      </div>

    </div>

    <van-popup v-model="showNationality" round position="bottom">
      <van-picker
        :title="$t('coll.choose')"
        :columns="columns"
        @cancel="showNationality = false"
        @confirm="onConfirm"
        value-key="title"
        ref="picker1"
        id="picker1"
        show-toolbar
      />
    </van-popup>

    <div class="ni-group-label">{{ $t("coll.nameInformation") }}</div>

    <!-- 中国国籍 -->
    <template v-if="isChina">
      <div class="ni-card">
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.legalChineseName") }}</span>
          <van-field
            v-model="step_data.name_cn"
            :placeholder="$t('global.please_input')"
            :disabled="!hasChanges"
            class="ni-inline-field"
          />
        </div>

        <div
          v-if="hasChanges && step_data.name_cn"
          class="ni-pinyin-banner"
          @click="fetchPinyin(step_data.name_cn)"
        >
          <span class="ni-pinyin-banner__text">{{ $t("coll.pinyinBannerText") }}</span>
          <div class="ni-pinyin-banner__btn">
            <i class="ti ti-sparkles" aria-hidden="true"></i>
            {{ $t("coll.pinyinBannerBtn") }}
          </div>
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.pinyinSurname") }}</span>
          <van-field
            v-model="step_data.last_name_en"
            :placeholder="$t('global.please_input')"
            :disabled="!hasChanges"
            class="ni-inline-field"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.pinyinGivenName") }}</span>
          <van-field
            v-model="step_data.first_name_en"
            :placeholder="$t('global.please_input')"
            :disabled="!hasChanges"
            class="ni-inline-field"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.nicknameLabel") }}</span>
          <van-field
            v-model="step_data.nick"
            :placeholder="$t('coll.optionalFill')"
            :disabled="!hasChanges"
            class="ni-inline-field ni-inline-field--optional"
          />
        </div>
      </div>
    </template>

    <!-- 非中国国籍 -->
    <template v-else>
      <div class="ni-card">
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.legalFirstName") }}</span>
          <van-field
            v-model="step_data.first_name_en"
            :placeholder="$t('global.please_input')"
            :disabled="!hasChanges"
            class="ni-inline-field"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.legalMiddleName") }}</span>
          <van-field
            v-model="step_data.middle_name_en"
            :placeholder="$t('coll.optionalFill')"
            :disabled="!hasChanges"
            class="ni-inline-field ni-inline-field--optional"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.legalLastName") }}</span>
          <van-field
            v-model="step_data.last_name_en"
            :placeholder="$t('global.please_input')"
            :disabled="!hasChanges"
            class="ni-inline-field"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.preferredName") }}</span>
          <van-field
            v-model="step_data.nick"
            :placeholder="$t('coll.optionalFill')"
            :disabled="!hasChanges"
            class="ni-inline-field ni-inline-field--optional"
          />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label" :class="!hasChanges ? 'ni-row__label--disabled' : ''">{{ $t("coll.chineseName") }}</span>
          <van-field
            v-model="step_data.name_cn"
            :placeholder="$t('coll.optionalFill')"
            :disabled="!hasChanges"
            class="ni-inline-field ni-inline-field--optional"
          />
        </div>
      </div>
    </template>

    <!--  上传照片 -->
    <div class="ni-group-label">{{ $t("coll.changedUpload") }}</div>
    <div class="ni-card ni-card--upload" :class="!hasChanges ? 'ni-card--disabled' : ''">
      <van-uploader
        :before-read="beforeRead"
        v-model="step_data.files1_url"
        @delete="deleteimg"
        :after-read="afterRead"
        name="medical"
        :disabled="!hasChanges"
      />
    </div>

    <!--  协议 -->
    <div v-if="protocol && protocol.length != 0">
      <protocol-sign
        @click="baseImg"
        :busProtocol="protocol"
        :base64="base64"
      ></protocol-sign>
    </div>

    <!--  提交按钮 -->
    <div class="mt-20">
      <van-button
        v-if="stepStatus == 4 && dataDetails.isCommon==1"
        disabled
        type="info"
        block
        round
        color="#4d88d2"
        class="saveSub"
      >{{ $t("coll.step_reviewed") }}</van-button>
      <a
        href="javascript:;"
        v-else
        @click="submitData()"
        class="saveBtnStep"
        :class="btnDisabled ? 'disabledSubmit' : ''"
      >{{ $t("global.submit") }}</a>
    </div>

  </div>
</template>


<!-- ============================================================
     以下 <script> 与原文件完全相同，无任何改动
     ============================================================ -->
<script>
import ProtocolSign from "@/components/steps/ProtocolSign";
import {Toast, Switch} from "vant";
import Vue from "vue";
import Compressor from 'compressorjs';
export default {
  components: {
    "protocol-sign": ProtocolSign,
    "van-switch": Switch,
  },
  props: {
    dataDetails: {
      type: Object,
      default: () => ({ data: {}, protocol: [], qiniu_token: '', signQiniuToken: '' })
    },
    status: { type: Number, default: 0 },
    disabled: { type: Number, default: 0 },
    protocol: { type: Array, default: () => [] },
  },
  name: "studentInfo",
  data() {
    return {
      country: "",
      showNationality: false,
      columns: [],
      btnDisabled: false,
      fileList: [],
      step_data: "",
      qiniuToken: '',
      type: "",
      base64: "",
      sign: "",
      signShow: false,
      sign_url: "",
      newSign: false,
      hasChanges: false,
    };
  },
  computed: {
    isChina() {
      var countryId = String(this.step_data.country || '');
      return countryId === '36' || countryId === 36 || countryId === '175' || countryId === 175;
    },
  },
  watch: {
    disabled() { this.btnDisabled = false; },
  },
  created() {
    this.stepStatus = this.status;
    this.step_data = (this.dataDetails && this.dataDetails.data) || {};
    Vue.set(this.step_data, 'country', String(this.step_data.country || ''));
    Vue.set(this.step_data, 'name_cn', this.step_data.name_cn ? this.step_data.name_cn + "" : "");
    Vue.set(this.step_data, 'nick', this.step_data.nick ? this.step_data.nick + "" : "");
    Vue.set(this.step_data, 'first_name_en', this.step_data.first_name_en ? this.step_data.first_name_en + "" : "");
    Vue.set(this.step_data, 'middle_name_en', this.step_data.middle_name_en ? this.step_data.middle_name_en + "" : "");
    Vue.set(this.step_data, 'last_name_en', this.step_data.last_name_en ? this.step_data.last_name_en + "" : "");
    Vue.set(this.step_data, 'license_number', this.step_data.license_number ? this.step_data.license_number + "" : "");
    this.step_data.files1_url = this.tojson(this.step_data.files1_url || []);
    this.step_data.files1 = this.step_data.files1 || [];
    this.hasChanges = this.step_data.has_changes == 1;
    this.qiniuToken = (this.dataDetails && this.dataDetails.qiniu_token) || '';
    var countryList = (this.dataDetails && this.dataDetails.country_list) || [];
    this.columns = countryList;
    for (var i = 0; i < countryList.length; i++) {
      if (String(countryList[i].id) === String(this.step_data.country)) {
        this.country = countryList[i].title;
        break;
      }
    }
    if (this.dataDetails && this.dataDetails.sign_url != "") {
      this.base64 = this.dataDetails.sign_url;
    }
  },
  methods: {
    showPicker() {
      if (!this.hasChanges) return;
      if (this.columns.length === 0) { Toast(this.$t('coll.countryListEmpty')); return; }
      this.showNationality = true;
      let that = this;
      this.$nextTick(() => {
        const country = String(that.step_data.country || '');
        that.index = this.lanIndex(country);
        if (that.index !== undefined && that.$refs.picker1) {
          that.$refs.picker1.setIndexes([that.index]);
        }
      });
    },
    lanIndex(id) {
      if (!id || !this.columns || this.columns.length === 0) return 0;
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].id == id) return i;
      }
      return 0;
    },
    onConfirm(value) {
      if (!value) return;
      Vue.set(this.step_data, 'country', String(value.id || ''));
      this.country = value.title || '';
      this.showNationality = false;
    },
    fetchPinyin(name) {
      var that = this;
      Toast.loading({ duration: 0, forbidClick: true, message: that.$t('coll.fetchingPinyin') });
      Vue.axios({ url: '/api/collection/namePinyin', method: 'post', data: { name } })
        .then(function (res) {
          Toast.clear();
          var data = Array.isArray(res) ? res : res.data;
          if (Array.isArray(data) && data.length >= 2) {
            Vue.set(that.step_data, 'last_name_en', data[0] || '');
            Vue.set(that.step_data, 'first_name_en', data[1] || '');
          } else { Toast(that.$t('coll.pinyinFailed')); }
        })
        .catch(function () { Toast.clear(); Toast(that.$t('coll.pinyinFailed')); });
    },
    tojson(rows) {
      return rows.map(r => ({ url: r }));
    },
    beforeRead(file) {
      return new Promise((resolve) => {
        new Compressor(file, { maxWidth: 1200, quality: 0.6, success: resolve,
          error(err) { console.log(err.message); } });
      });
    },
    afterRead(file, detail) {
      this.type = detail.name;
      if (file.length > 1) { for (let i in file) { this.upimg(file[i].content); } }
      else { this.upimg(file.content); }
    },
    upimg(data) {
      const that = this;
      Toast.loading({ duration: 0, forbidClick: true, message: that.$t("pickupcard.uploading") });
      var pic = data.substring(data.indexOf(",") + 1);
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          var resJson = JSON.parse(xhr.responseText);
          if (resJson.code == 0) { Toast(that.$t("pickupcard.Uploaded")); that.step_data.files1.push(resJson.data.key); }
          else { Toast(resJson.msg); }
        }
      };
      xhr.open("POST", "https://upload-z1.qiniup.com/putb64/-1", true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", "UpToken " + that.qiniuToken);
      xhr.send(pic);
    },
    deleteimg(file, detail) {
      this.step_data.files1_url.splice(detail.index, 1);
      this.step_data.files1.splice(detail.index, 1);
    },
    baseImg(data) {
      if (data != "cancel") { this.base64 = data; this.newSign = true; }
      this.signShow = false;
    },
    submitData() {
      let that = this;
      if (this.btnDisabled) return;
      if (!this.hasChanges) {
        this.$nextTick(() => { this.btnDisabled = true; });
        this.$emit("change", { has_changes: 0 });
        return;
      }
      if (this.isChina) {
        if (!that.step_data.name_cn) { Toast(that.$t('coll.pleaseInputChineseName')); return; }
      } else {
        if (!that.step_data.first_name_en) { Toast(that.$t('coll.pleaseInputFirstName')); return; }
        if (!that.step_data.last_name_en) { Toast(that.$t('coll.pleaseInputLastName')); return; }
      }
      if (!that.step_data.country) { Toast(this.$t('global.please_choose') + this.$t("coll.nationality")); return; }
      if (!that.step_data.license_number) { Toast(this.$t('global.please_input') + this.$t(that.isChina ? "coll.idCardNumber" : "coll.passportNumber")); return; }
      if (this.protocol && this.protocol.length != 0 && this.base64 == "") { Toast(that.$t("coll.please_sign")); return; }
      this.$nextTick(() => { this.btnDisabled = true; });
      if (!this.protocol || this.protocol.length == 0 || !that.newSign) { that.saveData(); return; }
      var pic = this.base64 && this.base64.substring(this.base64.indexOf(",") + 1);
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          var resJson = JSON.parse(xhr.responseText);
          if (resJson.code == 0) {
            Vue.set(that.step_data, "sign_url", resJson.data.url);
            Vue.set(that.step_data, "sign", resJson.data.key);
            that.saveData();
          } else { Toast(resJson.msg); that.btnDisabled = false; }
        }
      };
      xhr.open("POST", "https://upload-z1.qiniup.com/putb64/-1", true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", "UpToken " + that.dataDetails.signQiniuToken);
      xhr.send(pic);
    },
    saveData() {
      this.btnDisabled = true;
      Vue.set(this.step_data, 'has_changes', this.hasChanges ? 1 : 0);
      this.$emit("change", this.step_data);
    },
  },
};
</script>


<style lang="less" scoped>
/* ── 原有样式保留 ── */
.switchRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── 新增样式（ni- 前缀隔离） ── */

/* 是否变更 banner */
.ni-change-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding: 12px 14px;
  background: #eef4fd;
  border: 0.5px solid #b5d4f4;
  border-radius: 12px;
}
.ni-change-banner__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ni-change-banner__label {
  font-size: 14px;
  color: #185fa5;
  font-weight: 500;
}
.ni-change-banner__hint {
  font-size: 12px;
  color: #378add;
}

/* 分组标签 */
.ni-group-label {
  font-size: 11px;
  font-weight: 500;
  color: #888780;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 18px 0 6px 2px;
}

/* 分组卡片 */
.ni-card {
  background: #f7f8f9;
  border-radius: 12px;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* 通用行 */
.ni-row {
  display: flex;
  align-items: center;
  padding: 0 14px;
  min-height: 48px;
  gap: 8px;
  cursor: pointer;
}
.ni-row + .ni-row {
  border-top: 0.5px solid rgba(0, 0, 0, 0.06);
}
.ni-row--input {
  cursor: default;
  padding-right: 10px;
}
.ni-row__label {
  font-size: 13px;
  color: #888780;
  width: 130px;
  flex-shrink: 0;
}
.ni-row__value {
  font-size: 14px;
  color: #2c2c2a;
  flex: 1;
  text-align: right;
}
.ni-row__value--placeholder {
  color: #b4b2a9;
}

/* › 箭头 */
.ni-chevron {
  font-size: 18px;
  color: #b4b2a9;
  line-height: 1;
}
.ni-chevron--disabled {
  color: #d3d1c7;
}

/* disabled 文字色 */
.ni-row__label--disabled {
  color: #b4b2a9;
}
.ni-row__value--disabled {
  color: #b4b2a9;
}

/* 上传卡片 */
.ni-card--upload {
  background: #ffffff;
  border: 1.5px dashed rgba(0, 0, 0, 0.15);
  padding: 16px 14px;
  margin-top: 0;

  /deep/ .van-uploader__upload {
    background: #f0f4ff;
    border: 1px solid #b5d4f4;
    border-radius: 8px;
  }
  /deep/ .van-uploader__upload-icon {
    color: #1a6fe8;
  }
}
.ni-card--disabled {
  opacity: 0.45;
  pointer-events: none;
}

/* ── Pinyin banner ── */
.ni-pinyin-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 14px;
  background: #E6F1FB;
  border-top: 0.5px solid #B5D4F4;
  border-bottom: 0.5px solid #B5D4F4;
  cursor: pointer;
}
.ni-pinyin-banner__text {
  font-size: 12px;
  color: #185fa5;
}
.ni-pinyin-banner__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #0C447C;
  background: #fff;
  border: 0.5px solid #85B7EB;
  border-radius: 20px;
  padding: 4px 12px;
  flex-shrink: 0;
}
.ni-pinyin-banner__btn i {
  font-size: 13px;
}

/* 行内 van-field 重置：去掉 vant 自带背景/边框/padding，融入 ni-row */
.ni-inline-field {
  flex: 1;
  padding: 0 !important;
  background: transparent !important;

  /deep/ .van-field__control {
    font-size: 14px;
    color: #2c2c2a;
    text-align: right;
  }
  /deep/ .van-field__control::placeholder {
    color: #b4b2a9;
    font-size: 13px;
  }
  /deep/ .van-cell {
    padding: 0;
    background: transparent;
  }
}
</style>